import TextInput from "components/TextInput";
import styled from "styled-components";
import theme from "theme";

export const TextAreaWrapper = styled.div`
    margin-top: 1rem;

    ${TextInput.Style} {
        width: 400px;

        @media (${theme.breakpoints.mobileL}) {
            width: 100%;
        }
    }

    textarea {
        padding-right: 10px;
        height: 150px;
    }
`;

export const OtherInterestGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 3rem;
    row-gap: 2rem;
    margin-top: 2rem;
    width: fit-content;
`;
